import AnimatedLine, { AnimatedLineConfig } from "./AnimatedLine";

const config: AnimatedLineConfig = {
    viewBox: "0 0 597 265",
    path: "M0.0507812 264.5C264.174 238.224 278.529 -7.19711 596.051 0.685805",
    dashArray: "2.33 2.33",
    dots: [
        { cx: 159.951, cy: 211.085, r: 8, delay: 0.5 },
        { cx: 278.026, cy: 119.783, r: 8, delay: 1.0 },
        { cx: 359.106, cy: 59.739, r: 8, delay: 1.5 },
    ],
    gradient: { x: 298.051, y1: 0.5, y2: 264.5 },
};

const Line6 = ({ className }: { className?: string }) => (
    <AnimatedLine {...config} className={className} />
);

export default Line6;
